import { useRef, useState } from "react";
import { ConvertBoxDataType } from "../convertBox.index";
import { __EnterPayeerAccountProps } from "./enterPayeerAccount.interface";
import { Card } from "utilities/components";
import { Alert, Button, Input } from "30pay/components";
import { HiArrowLeft, HiArrowRight } from "react-icons/hi2";
import ConvertBoxConfirmOrderModal from '30pay/trade/convertBox/confirmOrderModal/orderDetailModal.index';
import { __ConvertBoxConfirmOrderDetailModalRef } from "../confirmOrderModal/orderDetailModal.interface";
import { __BuyPaymentMethodsEnum } from "../buyPaymentMethod/buyPaymentMethod.interface";
import { post } from "scripts";
import { API } from "data/30pay.api";
import { useNavigate } from "react-router-dom";

const EnterPayeerAccount: React.FC<__EnterPayeerAccountProps> = (props: __EnterPayeerAccountProps) => {
    const [payeerAccount, setPayeerAccount] = useState('');
    const [confirmData, setConfirmData] = useState<ConvertBoxDataType>();
    const confirmModalRef = useRef<__ConvertBoxConfirmOrderDetailModalRef>(null);
    const navigate = useNavigate();

    function finalSubmission() {
        confirmModalRef.current?.startLoading();
        const PayeerBody = {
            destinationAccount: payeerAccount,
            amount: props.data?.srcValue,
            cardNumberId: props.data?.bankAccountId,
            source: props.data?.buyPaymentMethod === __BuyPaymentMethodsEnum.Gateway ? 1 : 0,
        };

        // Don't send cardNumberId if source is wallet
        if (PayeerBody.source === 0) delete PayeerBody.cardNumberId;

        post<any>(API.orderTransaction.buyPayeer, PayeerBody).then((res) => {
            setConfirmData(props.data);
            if (res.value.value.paymentUrl) navigate(res.value.value.paymentUrl);
        })
            .catch((e) => console.log(e))
            .finally(() => confirmModalRef.current?.stopLoading());
    }

    function submitHandler() {
        const output: ConvertBoxDataType = {
            destinationAccount: payeerAccount,
        };
        setConfirmData({ ...props.data, ...output });
    }

    function backHandler() {
        props.onBack();
    }

    return (
        <div className="flex max-lg:flex-col gap-6 h-full">
            <ConvertBoxConfirmOrderModal
                ref={confirmModalRef}
                data={confirmData}
                isOpen={!!confirmData}

                onClose={(needReFetch) => {
                    setConfirmData(undefined);
                    needReFetch && props.onFinish();
                }}
                submitButton={{
                    title:
                        props.data?.buyPaymentMethod === __BuyPaymentMethodsEnum.Gateway
                            ? 'انتقال به درگاه'
                            : 'تایید سفارش',
                    onClick: finalSubmission,
                }}
            />
            <Card className="flex-1" title="اطلاعات حساب مقصد" titleDivider>
                <div className="flex flex-col gap-6">
                    <div className="gap-2 flex flex-col">
                        <label className="font-bold text-base text-black-100 text-right">نام کاربری حساب:</label>
                        <Input
                            className={payeerAccount && payeerAccount !== '' ? 'en' : ''}
                            value={payeerAccount}
                            onPressEnter={() => setConfirmData(props.data)}
                            onChange={(e) => setPayeerAccount(e.target.value)}
                            placeholder="نام کاربری حساب خود را وارد نمایید."
                        />
                    </div>
                </div>
                <div className="flex items-center w-full gap-4 mt-6">
                    <Button
                        disabled={!payeerAccount || payeerAccount === ''}
                        onClick={submitHandler}
                        className="w-full h-16"
                        type="primary"
                    >
                        <HiArrowRight />
                        ادامه
                    </Button>
                    <Button onClick={backHandler} className="w-full h-16 bg-background" type="text">
                        بازگشت
                        <HiArrowLeft />
                    </Button>
                </div>
            </Card>
            <div className="flex flex-col gap-6 flex-1">
                <Alert message="دقت داشته باشید که در صورت داشتن حساب کاربری پاییر نام کاربری خود را در قسمت خواسته شده وارد کرده و سپس ادامه روند خرید را پیش ببرید." variant="info" />
            </div>
        </div>
    );
}

export default EnterPayeerAccount;